import Vue from 'vue';
import Vuex from 'vuex';

import spotify from './modules/spotify'
import user from './modules/user'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    spotify,
    user
  },
})